<template>
  <div class="account-settings">
    <h1 class="settings-title">
      Profile
    </h1>
    <div class="settings-form">
      <h2 class="settings-subtitle">
        Account Details
      </h2>
      <div class="account-settings__image-block">
        <file-upload
          ref="fileUpload"
          :drop="false"
          type="image/png,image/jpeg"
          @input-file="handleFileChange">
          <span class="upload-area">
            <span
              :style="avatar ? `background-image: url(${avatar})` : ''"
              :class="{loading: loadingAvatar}"
              class="user-avatar">
              {{ avatar ? '' : userName | initials }}
              <div class="loader"><div class="loading-circle"/></div>
            </span>
            <span class="upload-avatar">
              <icon
                name="upload"
                width="12"
                height="12"/> Upload new photo
            </span>
            <span class="upload-info">JPEG/PNG</span>
          </span>
          <span
            v-if="validationErrors.avatar"
            class="validation-error">{{ validationErrors.avatar }}</span>
        </file-upload>
      </div>
      <div>
        <b-form-group>
          <label
            for="first-name"
            class="settings-label">
            First Name
          </label>
          <b-input
            id="first-name"
            v-model="firstName"
            v-validate="'required'"
            name="first_name"
            data-vv-as="First name"
            type="text"
            placeholder="First Name"
            autofocus/>
        </b-form-group>
        <span
          v-if="errors.has('first_name')"
          class="validation-error">{{ errors.first('first_name') }}</span>
        <span
          v-if="validationErrors.firstName"
          class="validation-error">{{ validationErrors.firstName }}</span>
      </div>
      <div>
        <b-form-group>
          <label
            for="last-name"
            class="settings-label">
            Last Name
          </label>
          <b-input
            id="last-name"
            v-model="lastName"
            v-validate="'required'"
            name="last_name"
            data-vv-as="Last name"
            type="text"
            placeholder="Last Name"/>
        </b-form-group>
        <span
          v-if="errors.has('last_name')"
          class="validation-error">{{ errors.first('last_name') }}</span>
        <span
          v-if="validationErrors.lastName"
          class="validation-error">{{ validationErrors.lastName }}</span>
      </div>
    </div>
    <div
      v-if="profileUpdated"
      class="account-settings__success">
      Profile info has been successfully updated.
    </div>
    <div
      v-if="errorMessage"
      class="account-settings__error">
      {{ errorMessage }}
    </div>
    <b-button
      :class="{loading: saving}"
      :disabled="saving"
      class="account-settings__submit btn-round"
      @click="saveUser">
      <span v-if="!saving">Save</span>
      <div class="loader"><div class="loading-circle"/></div>
    </b-button>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component';
import setValidationErrors from '@/helpers/validationErrors';
import { mapActions, mapGetters } from 'vuex';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'user/getField',
  mutationType: 'user/updateField',
});

export default {
  name: 'ProfileSettings',
  components: {
    FileUpload,
  },
  data() {
    return {
      saving: false,
      loadingAvatar: false,
      profileUpdated: false,
      errorMessage: '',
      validationErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      userName: 'user/name',
      userLoaded: 'user/userLoaded',
      successUpdate: 'user/successUpdate',
      apiError: 'user/apiError',
    }),
    ...mapFields([
      'avatar',
      'firstName',
      'lastName',
    ]),
  },
  watch: {
    successUpdate(success) {
      if (success) {
        this.saving = false;
        this.profileUpdated = true;
        setTimeout(() => {
          this.profileUpdated = false;
        }, 3000);
      }
    },
    avatar() {
      this.loadingAvatar = false;
    },
    apiError(error) {
      this.saving = false;
      this.loadingAvatar = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  mounted() {
    if (!this.userLoaded) {
      this.fetchUser();
    }
  },
  methods: {
    ...mapActions({
      fetchUser: 'user/fetchUser',
      updateUser: 'user/updateUser',
      updateAvatar: 'user/updateAvatar',
    }),
    saveUser() {
      this.errorMessage = '';
      this.validationErrors = {};
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.saving = true;
          const user = {
            first_name: this.firstName,
            last_name: this.lastName,
          };
          this.updateUser(user);
        }
      });
    },
    handleFileChange(file) {
      if (file) {
        this.loadingAvatar = true;

        const formData = new FormData();
        formData.append('avatar', file.file);

        this.updateAvatar(formData);
      }
    },
  },
};
</script>
